
import ReviewButton from "./ReviewButton.vue"
import OrderTreatmentDetails from "../../OrderHistory/components/OrderTreatmentDetails.vue";
import NoShowTreatmentDetails from './NoShowTreatmentDetails.vue'
import { CommonDialog } from "../../../../Common/CommonComponents";
import OrderProductDetails from "../../OrderHistory/components/OrderProductDetails.vue";
import ProfileSvc from '../../../../../services/profile-svc';
let profileSvc = null;
export default {
  components: { OrderProductDetails, OrderTreatmentDetails, NoShowTreatmentDetails, CommonDialog, ReviewButton },
  props: {
    layout: {
      required: false,
      default: null,
      type: String,
    },
    orderDetailed: {
      required: true
    },
    title: {
      required: true
    },
    canCancel: {
      type: Boolean
    },
    canRepeatBooking: {
      type: Boolean
    },
    canSeeReceipt: {
      type: Boolean
    },
    canAddToCalendar: {
      type: Boolean
    },
    canSendReview: {
      type: Boolean
    },
    canCancelWithFee: {
      type: Boolean
    },
    canPayNoShow: {
      type: Boolean
    },
    canContactSalon: {
      type: Boolean
    },
    canEditAppointment: {
      type: Boolean
    },
    returnToProfileButton: {
      type: Boolean
    },
    goToHistoryButton: {
      type: Boolean
    },
    isNoShow: {
      type: Boolean
    },
    treatmentsOnly: {
      type: Boolean
    },
    productsOnly: {
      type: Boolean
    },
    terms: {},
    termsIcon: {},
  },
  data: () => ({
    loading: false,
    showDialog: false,
    showCancelFeeDialog: false,
    showFairPayCreateError: false,
    sentReview: false
  }),
  computed: {
    siteId() {
      return this.layout == "portal"
        ? this.$route.params.siteId
        : this.$route.query.siteId;
    },
    portalUrl() {
      return this.layout == "portal"
        ? process.env.VUE_APP_FIXIT_NO_URL
        : this.$config.VUE_APP_FIXIT_NO_URL
        ? this.$config.VUE_APP_FIXIT_NO_URL
        : process.env.VUE_APP_FIXIT_NO_URL;
    },
    profileUrl() {
      return this.layout == "portal"
        ? process.env.VUE_APP_FIXIT_PROFILE_URL
        : this.$config.VUE_APP_FIXIT_PROFILE_URL
        ? this.$config.VUE_APP_FIXIT_PROFILE_URL
        : process.env.VUE_APP_FIXIT_PROFILE_URL;
    },
    bookingApi() {
        return this.layout == 'portal' ? process.env.VUE_APP_FIXIT_NO_BOOKING_URL : this.$config.VUE_APP_FIXIT_NO_BOOKING_URL ? this.$config.VUE_APP_FIXIT_NO_BOOKING_URL : process.env.VUE_APP_FIXIT_NO_BOOKING_URL
    },
  },
  methods: {
    async repeatOrder() {
        let treatmentDict = []
        if (this.orderDetailed.treatments.length) {
          this.orderDetailed.treatments.forEach((x) => {
            if (!x.notBookable) {
              treatmentDict.push(x.treatmentId)
            }
          })
          if (treatmentDict.length) {
            await profileSvc.RepeatOrder(
              {
                productDict: {},
                treatmentDict: treatmentDict,
                siteId: this.orderDetailed.siteId,
                clientUuid: '' //use this?
              }
            ).then((res) => {
              if (res) {
                window.open(`${this.portalUrl}/frisor/${this.orderDetailed.urlSafeSiteName}/${this.orderDetailed.siteId}/checkout`, '_self')
              }
            })
          }
        }
    },
    editAppointment() {
      window.open(`${this.portalUrl}/frisor/${this.orderDetailed.urlSafeSiteName}/${this.orderDetailed.siteId}/endre/${this.orderDetailed.base64AppointmentId}`, '_self')
    },
    appendTreatmentsIds(order) {
      var treatmentList = order.treatments
        .map((x) => btoa(x.treatmentId))
        .join(",");
      if (treatmentList.length > 0) {
        return `treatmentIds=${treatmentList}`;
      }
      return null;
    },
    previousTreatmentUrl(order) {
    if (this.layout == "portal") {
      return `${this.portalUrl}/frisor/${this.orderDetailed.urlSafeSiteName}/${
        this.orderDetailed.siteId
      }?${this.appendTreatmentsIds(order)}`;
    } else {
      return `${this.portalUrl}/booking/${this.orderDetailed.siteId}?${this.appendTreatmentsIds(order)}`;
    }
    },
    repeatOrderOld(order) {
      window.open(this.previousTreatmentUrl(order), "_blank");
    },
    async cancelAppointment(appointmentId) {
      this.loading = true;
      if (
        await profileSvc.CancelAppointment(
          this.bookingApi,
          this.siteId.toString(),
          this.isTpn ? "True" : "False",
          appointmentId
        )
      ) {
        this.$emit('update')
        this.showDialog = false;
      }
      this.loading = false;
    },
    receiptRedirect() {
      if (this.layout == "portal") {
        window.open(
          `https://receipt.onlinetimebok.no/receipt?receiptId=${this.orderDetailed.receiptId}`,
          "_blank"
        );
      } else {
        this.$router.replace(
          `/receipt?receiptId=${this.orderDetailed.receiptId}`
        );
      }
    },
    contactSalon() {
      if (this.layout === 'portal') {
        window.open(`${this.portalUrl}/frisor/${this.orderDetailed.urlSafeSiteName}/${this.orderDetailed.siteId}`, `_self`)
      } else {
        this.$router.push(`/about/${this.orderDetailed.urlSafeSiteName}`)
      }
    },
    returnToProfile() {
      if (this.layout === 'portal') {
        this.$router.push('/profil')
      } else {
        this.$router.push({query: { title: 'Profil'}})
      }
    },
    goToHistory() {
      if (this.layout === 'portal') {
        this.$router.push('/bestillinger')
      } else {
        this.$router.push({query: { title: 'bestillinger'}})
      }
    },
    toggleCancelFeeDialog() {
      this.showCancelFeeDialog = !this.showCancelFeeDialog;
    },
    toggleFairPayCreateError() {
      this.showFairPayCreateError = !this.showFairPayCreateError;
    },
    async cancelAppointmentAndCreateFairpay() {
      return await this.$store.dispatch('fairpay/cancelAppointmentAndCreate', {
          fixitSiteId: this.orderDetailed.fixitSiteId,
          timebokBesokId: this.orderDetailed.appointmentId
      })
    },
    async goToPayment(type) {
      if (this.layout === 'portal') {
        if (type === 'cancel') {
          await this.cancelAppointmentAndCreateFairpay().then((res) => {
            this.toggleCancelFeeDialog()
            if (res) {
              this.$router.push({name: 'Valg av betalingsmetode for kansellering', params: {id: this.orderDetailed.base64AppointmentId, siteId: this.orderDetailed.siteId, order: this.orderDetailed}}) 
            } else {
              this.$emit('update')
              this.toggleFairPayCreateError()
            }
          })
        } else {
          this.$router.push({name: 'Valg av betalingsmetode', params: {id: this.orderDetailed.base64AppointmentId, siteId: this.orderDetailed.siteId, order: this.orderDetailed}})
        }
      } else {
        if (type === 'cancel') {
          await this.cancelAppointmentAndCreateFairpay().then((res) => {
            this.toggleCancelFeeDialog()
            if (res) {
              window.open(`${this.profileUrl}/sen-kansellering/${this.orderDetailed.siteId}/${this.orderDetailed.base64AppointmentId}/betaling`, `_self`)
            } else {
              this.$emit('update')
              this.toggleFairPayCreateError()
            }
          })
        } else {
          window.open(`${this.profileUrl}/ikke-mott/${this.orderDetailed.siteId}/${this.orderDetailed.base64AppointmentId}/betaling`, `_self`)
        }
      }
      },
  },
  mounted() {
    const calendarConfig = {
    name: `Time hos ${this.orderDetailed.siteName}`,
    description: `Time hos ${this.orderDetailed.siteName}, ${this.$moment(this.orderDetailed.appointmentDate).format("dddd D. MMMM") } kl ${this.$moment(this.orderDetailed.appointmentDate).format("HH:mm")}`,
    startDate: this.$moment(this.orderDetailed.appointmentDate).format("YYYY-MM-DD"),
    startTime: this.$moment(this.orderDetailed.startTimeTreatments).format("HH:mm"),
    endTime: this.$moment(this.orderDetailed.endTimeTreatments).format("HH:mm"),
    timeZone: "Europe/Oslo",
    options: ["Google", "iCal", "MicrosoftTeams", "Microsoft365", "Outlook.com", "Yahoo", "Apple"],
  };
  const button = document.getElementById('add-to-calendar');
  if (button) {
    button.addEventListener('click', () => atcb_action(calendarConfig, button));
  }
  },
  async created() {
      profileSvc = await ProfileSvc(this.$axios);
  },
  beforeDestroy() {
    profileSvc = null
  }
}
